import { PlaceOrderQueueItem } from "../../../core/models/entities/PlaceOrderQueueItem";
import { PlaceOrderQueueItemDto } from "../responses/PlaceOrderQueueItemDto";

export function mapToPlaceOrderQueueItem(
  dto: PlaceOrderQueueItemDto,
): PlaceOrderQueueItem {
  return {
    id: dto.id,
    orgId: dto.orgId,
    userB2CId: dto.userB2CId,
    isAdmin: dto.isAdmin,
    orderNumber: dto.orderNumber,
    status: dto.status,
    orderId: dto.orderId,
    errorMessage: dto.errorMessage ?? undefined,
    createdAtUtc: new Date(dto.createdAtUtc),
    updatedAtUtc: new Date(dto.updatedAtUtc),
    createdBy: dto.createdBy,
    requestBody: dto.requestBody ?? undefined,
  };
}
